import {ProductModel} from "../../Models/ProductModel";

export const pdv144Products: ProductModel[] = [
    {
        priceTTC: 4,
        depositPriceTTC: 2,
        product: {
            id: 105,
            name: "Pepsi",
            privateName: "Pepsi 33cl",
            size: "33cl",
            image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-ErL51SV6ezXuj2bJ3eGS7INw/user-X43ayra8pW70uVNqsHudSfGM/img-JRYtTGJaqGgTznUbFUUh1hsF.png?st=2023-07-27T19%3A07%3A11Z&se=2023-07-27T21%3A07%3A11Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-07-27T15%3A32%3A22Z&ske=2023-07-28T15%3A32%3A22Z&sks=b&skv=2021-08-06&sig=czVLxx%2BX%2BmYjQsYJ6Gzqgx6n7riKweRUC21rZVLgE74%3D",
            productCategories: [
                { name: "Soft", productCategoryFamily: { name: "SOFT" } },
                { name: "Boisson tout type" },
                { name: "Boisson soft ou bière" }
            ],
            tva: { id: 1, name: "10%", rate: 10 },
            isMenu: false
        },
        automaticDiscounts: [
            {
                name: "HO",
                startedAt: "2023-01-25T12:00:00+01:00",
                endedAt: "2024-02-25T16:30:00+01:00",
                discount: { id: 4, name: "2=3", rate: 2, rateTotal: 3, type: "quantity" }
            }
        ],
        stockAvailable: 0,
        eventPdvProducts: []
    },
    {
        priceTTC: 7,
        depositPriceTTC: 2,
        product: {
            id: 116,
            name: "Bière Arena",
            privateName: "Bière Arena 50cl",
            size: "50cl",
            image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-ErL51SV6ezXuj2bJ3eGS7INw/user-X43ayra8pW70uVNqsHudSfGM/img-JRYtTGJaqGgTznUbFUUh1hsF.png?st=2023-07-27T19%3A07%3A11Z&se=2023-07-27T21%3A07%3A11Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-07-27T15%3A32%3A22Z&ske=2023-07-28T15%3A32%3A22Z&sks=b&skv=2021-08-06&sig=czVLxx%2BX%2BmYjQsYJ6Gzqgx6n7riKweRUC21rZVLgE74%3D",
            productCategories: [
                { name: "Bière avec alcool", productCategoryFamily: { name: "AVEC ALCOOL" } },
                { name: "Alcool" },
                { name: "Boisson tout type" },
                { name: "Boisson soft ou bière" },
                { name: "Boisson Soft ou Bière ou Vin" }
            ],
            tva: { id: 1, name: "20%", rate: 20 },
            isMenu: false
        },
        automaticDiscounts: [
            {
                name: "H2",
                startedAt: "2023-01-25T12:00:00+01:00",
                endedAt: "2024-02-25T16:30:00+01:00",
                discount: { id: 5, name: "10%", rate: 10, rateTotal: 10, type: "percent" }
            }
        ],
        stockAvailable: 2,
        eventPdvProducts: []
    },
    {
        priceTTC: 4,
        depositPriceTTC: 0,
        product: {
            id: 122,
            name: "Chips Lays 45g",
            privateName: "Chips Lays 45g",
            size: "45g",
            image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-ErL51SV6ezXuj2bJ3eGS7INw/user-X43ayra8pW70uVNqsHudSfGM/img-JRYtTGJaqGgTznUbFUUh1hsF.png?st=2023-07-27T19%3A07%3A11Z&se=2023-07-27T21%3A07%3A11Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-07-27T15%3A32%3A22Z&ske=2023-07-28T15%3A32%3A22Z&sks=b&skv=2021-08-06&sig=czVLxx%2BX%2BmYjQsYJ6Gzqgx6n7riKweRUC21rZVLgE74%3D",
            productCategories: [{ name: "Snack", productCategoryFamily: { name: "ALIMENTAIRE" } }],
            tva: { id: 1, name: "10%", rate: 10 },
            isMenu: false
        },
        automaticDiscounts: [
            {
                name: "HO",
                startedAt: "2023-01-25T12:00:00+01:00",
                endedAt: "2024-02-25T16:30:00+01:00",
                discount: { id: 4, name: "2=3", rate: 2, rateTotal: 3, type: "quantity" }
            }
        ],
        stockAvailable: 5,
        eventPdvProducts: []
    },
    {
        priceTTC: 2,
        depositPriceTTC: 0,
        product: {
            id: 118,
            name: "Sandwich poulet",
            privateName: "Sandwich poulet",
            image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-ErL51SV6ezXuj2bJ3eGS7INw/user-X43ayra8pW70uVNqsHudSfGM/img-JRYtTGJaqGgTznUbFUUh1hsF.png?st=2023-07-27T19%3A07%3A11Z&se=2023-07-27T21%3A07%3A11Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-07-27T15%3A32%3A22Z&ske=2023-07-28T15%3A32%3A22Z&sks=b&skv=2021-08-06&sig=czVLxx%2BX%2BmYjQsYJ6Gzqgx6n7riKweRUC21rZVLgE74%3D",
            productCategories: [
                { name: "Alimentaire", productCategoryFamily: { name: "ALIMENTAIRE" } },
                { name: "Sandwich" }
            ],
            tva: { id: 1, name: "10%", rate: 10 },
            isMenu: false
        },
        automaticDiscounts: [],
        stockAvailable: 4,
        eventPdvProducts: []
    },
    {
        priceTTC: 4,
        depositPriceTTC: 2,
        product: {
            id: 107,
            name: "Pepsi max",
            privateName: "Pepsi max 33cl",
            size: "33cl",
            image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-ErL51SV6ezXuj2bJ3eGS7INw/user-X43ayra8pW70uVNqsHudSfGM/img-JRYtTGJaqGgTznUbFUUh1hsF.png?st=2023-07-27T19%3A07%3A11Z&se=2023-07-27T21%3A07%3A11Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-07-27T15%3A32%3A22Z&ske=2023-07-28T15%3A32%3A22Z&sks=b&skv=2021-08-06&sig=czVLxx%2BX%2BmYjQsYJ6Gzqgx6n7riKweRUC21rZVLgE74%3D",
            productCategories: [
                { name: "Soft", productCategoryFamily: { name: "SOFT" } },
                { name: "Boisson tout type" },
                { name: "Boisson soft ou bière" }
            ],
            tva: { id: 1, name: "10%", rate: 10 },
            isMenu: false
        },
        automaticDiscounts: [
            {
                name: "HO",
                startedAt: "2023-01-25T12:00:00+01:00",
                endedAt: "2023-02-25T16:30:00+01:00",
                discount: { id: 4, name: "2=3", rate: 2, rateTotal: 3, type: "quantity" }
            }
        ],
        stockAvailable: 3,
        eventPdvProducts: []
    },
    {
        priceTTC: 7,
        depositPriceTTC: 2,
        product: {
            id: 117,
            name: "Bière kro",
            privateName: "Bière kro 50cl",
            size: "50cl",
            image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-ErL51SV6ezXuj2bJ3eGS7INw/user-X43ayra8pW70uVNqsHudSfGM/img-JRYtTGJaqGgTznUbFUUh1hsF.png?st=2023-07-27T19%3A07%3A11Z&se=2023-07-27T21%3A07%3A11Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-07-27T15%3A32%3A22Z&ske=2023-07-28T15%3A32%3A22Z&sks=b&skv=2021-08-06&sig=czVLxx%2BX%2BmYjQsYJ6Gzqgx6n7riKweRUC21rZVLgE74%3D",
            productCategories: [
                { name: "Bière avec alcool", productCategoryFamily: { name: "AVEC ALCOOL" } },
                { name: "Alcool" },
                { name: "Boisson tout type" },
                { name: "Boisson soft ou bière" },
                { name: "Boisson Soft ou Bière ou Vin" }
            ],
            tva: { id: 1, name: "20%", rate: 20 },
            isMenu: false
        },
        automaticDiscounts: [
            {
                name: "H2",
                startedAt: "2023-01-25T12:00:00+01:00",
                endedAt: "2024-02-25T16:30:00+01:00",
                discount: { id: 5, name: "10%", rate: 10, rateTotal: 10, type: "percent" }
            }
        ],
        stockAvailable: 0,
        eventPdvProducts: []
    },
    {
        priceTTC: 4,
        depositPriceTTC: 0,
        product: {
            id: 123,
            name: "kinder bueno",
            privateName: "kinder bueno",
            image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-ErL51SV6ezXuj2bJ3eGS7INw/user-X43ayra8pW70uVNqsHudSfGM/img-JRYtTGJaqGgTznUbFUUh1hsF.png?st=2023-07-27T19%3A07%3A11Z&se=2023-07-27T21%3A07%3A11Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-07-27T15%3A32%3A22Z&ske=2023-07-28T15%3A32%3A22Z&sks=b&skv=2021-08-06&sig=czVLxx%2BX%2BmYjQsYJ6Gzqgx6n7riKweRUC21rZVLgE74%3D",
            productCategories: [{ name: "Snack", productCategoryFamily: { name: "ALIMENTAIRE" } }],
            tva: { id: 1, name: "10%", rate: 10 },
            isMenu: false
        },
        automaticDiscounts: [
            {
                name: "HO",
                startedAt: "2023-01-25T12:00:00+01:00",
                endedAt: "2024-02-25T16:30:00+01:00",
                discount: { id: 4, name: "2=3", rate: 2, rateTotal: 3, type: "quantity" }
            }
        ],
        stockAvailable: 0,
        eventPdvProducts: []
    },
    {
        priceTTC: 2,
        depositPriceTTC: 0,
        product: {
            id: 119,
            name: "Sandwich poisson",
            privateName: "Sandwich poisson",
            image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-ErL51SV6ezXuj2bJ3eGS7INw/user-X43ayra8pW70uVNqsHudSfGM/img-JRYtTGJaqGgTznUbFUUh1hsF.png?st=2023-07-27T19%3A07%3A11Z&se=2023-07-27T21%3A07%3A11Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-07-27T15%3A32%3A22Z&ske=2023-07-28T15%3A32%3A22Z&sks=b&skv=2021-08-06&sig=czVLxx%2BX%2BmYjQsYJ6Gzqgx6n7riKweRUC21rZVLgE74%3D",
            productCategories: [
                { name: "Alimentaire", productCategoryFamily: { name: "ALIMENTAIRE" } },
                { name: "Sandwich" }
            ],
            tva: { id: 1, name: "10%", rate: 10 },
            isMenu: false
        },
        automaticDiscounts: [],
        stockAvailable: 0,
        eventPdvProducts: []
    },
    {
        priceTTC: 4,
        depositPriceTTC: 2,
        product: {
            id: 108,
            name: "Pepsi cerise",
            privateName: "Pepsi cerise 33cl",
            size: "33cl",
            image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-ErL51SV6ezXuj2bJ3eGS7INw/user-X43ayra8pW70uVNqsHudSfGM/img-JRYtTGJaqGgTznUbFUUh1hsF.png?st=2023-07-27T19%3A07%3A11Z&se=2023-07-27T21%3A07%3A11Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-07-27T15%3A32%3A22Z&ske=2023-07-28T15%3A32%3A22Z&sks=b&skv=2021-08-06&sig=czVLxx%2BX%2BmYjQsYJ6Gzqgx6n7riKweRUC21rZVLgE74%3D",
            productCategories: [
                { name: "Soft", productCategoryFamily: { name: "SOFT" } },
                { name: "Boisson tout type" },
                { name: "Boisson soft ou bière" }
            ],
            tva: { id: 1, name: "10%", rate: 10 },
            isMenu: false
        },
        automaticDiscounts: [
            {
                name: "HO",
                startedAt: "2023-01-25T12:00:00+01:00",
                endedAt: "2024-02-25T16:30:00+01:00",
                discount: { id: 4, name: "2=3", rate: 2, rateTotal: 3, type: "quantity" }
            }
        ],
        stockAvailable: 0,
        eventPdvProducts: []
    },
    {
        priceTTC: 7,
        depositPriceTTC: 2,
        product: {
            id: 115,
            name: "Bière heineken",
            privateName: "Bière heineken 50cl",
            size: "50cl",
            image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-ErL51SV6ezXuj2bJ3eGS7INw/user-X43ayra8pW70uVNqsHudSfGM/img-JRYtTGJaqGgTznUbFUUh1hsF.png?st=2023-07-27T19%3A07%3A11Z&se=2023-07-27T21%3A07%3A11Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-07-27T15%3A32%3A22Z&ske=2023-07-28T15%3A32%3A22Z&sks=b&skv=2021-08-06&sig=czVLxx%2BX%2BmYjQsYJ6Gzqgx6n7riKweRUC21rZVLgE74%3D",
            productCategories: [
                { name: "Bière avec alcool", productCategoryFamily: { name: "AVEC ALCOOL" } },
                { name: "Alcool" },
                { name: "Boisson tout type" },
                { name: "Boisson soft ou bière" },
                { name: "Boisson Soft ou Bière ou Vin" }
            ],
            tva: { id: 1, name: "20%", rate: 20 },
            isMenu: false
        },
        automaticDiscounts: [
            {
                name: "H2",
                startedAt: "2023-01-25T12:00:00+01:00",
                endedAt: "2024-02-25T16:30:00+01:00",
                discount: { id: 5, name: "10%", rate: 10, rateTotal: 10, type: "percent" }
            }
        ],
        stockAvailable: 0,
        eventPdvProducts: []
    },
    {
        priceTTC: 4,
        depositPriceTTC: 0,
        product: {
            id: 124,
            name: "kinder country",
            privateName: "kinder country",
            image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-ErL51SV6ezXuj2bJ3eGS7INw/user-X43ayra8pW70uVNqsHudSfGM/img-JRYtTGJaqGgTznUbFUUh1hsF.png?st=2023-07-27T19%3A07%3A11Z&se=2023-07-27T21%3A07%3A11Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-07-27T15%3A32%3A22Z&ske=2023-07-28T15%3A32%3A22Z&sks=b&skv=2021-08-06&sig=czVLxx%2BX%2BmYjQsYJ6Gzqgx6n7riKweRUC21rZVLgE74%3D",
            productCategories: [{ name: "Snack", productCategoryFamily: { name: "ALIMENTAIRE" } }],
            tva: { id: 1, name: "10%", rate: 10 },
            isMenu: false
        },
        automaticDiscounts: [
            {
                name: "HO",
                startedAt: "2023-01-25T12:00:00+01:00",
                endedAt: "2024-02-25T16:30:00+01:00",
                discount: { id: 4, name: "2=3", rate: 2, rateTotal: 3, type: "quantity" }
            }
        ],
        stockAvailable: 0,
        eventPdvProducts: []
    },
    {
        priceTTC: 2,
        depositPriceTTC: 0,
        product: {
            id: 120,
            name: "Sandwich boeuf",
            privateName: "Sandwich boeuf",
            image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-ErL51SV6ezXuj2bJ3eGS7INw/user-X43ayra8pW70uVNqsHudSfGM/img-JRYtTGJaqGgTznUbFUUh1hsF.png?st=2023-07-27T19%3A07%3A11Z&se=2023-07-27T21%3A07%3A11Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-07-27T15%3A32%3A22Z&ske=2023-07-28T15%3A32%3A22Z&sks=b&skv=2021-08-06&sig=czVLxx%2BX%2BmYjQsYJ6Gzqgx6n7riKweRUC21rZVLgE74%3D",
            productCategories: [
                { name: "Alimentaire", productCategoryFamily: { name: "ALIMENTAIRE" } },
                { name: "Sandwich" }
            ],
            tva: { id: 1, name: "10%", rate: 10 },
            isMenu: false
        },
        automaticDiscounts: [],
        stockAvailable: 0,
        eventPdvProducts: []
    },
  {
    priceTTC: 9.0,
    depositPriceTTC: 1.0,
    product: {
      id: 2247,
      name: "Bi\u00e8re Krombacher 40cl, 4.8% vol.",
      privateName: "Bi\u00e8re Krombacher 4.8\u00b0 40cl + Consigne",
      image: "https:\/\/api.stonebytopivo.fr\/v1\/public\/cache\/product_image\/images\/product\/670fd5e696158_krombacher_international_logo_15_2c_pos_high_2.jpg",
      productCategories: [
        {
          name: "BI\u00c8RE AVEC ALCOOL",
          productCategoryFamily: { name: "AVEC ALCOOL" }
        }
      ],
      tva: undefined,
      isMenu: true
    },
    automaticDiscounts: [],
    stockAvailable: 270,
    eventPdvProducts: [
      {
        priceTTC: 0,
        depositPriceTTC: 0,
        product: {
          id: 2770,
          name: "Bi\u00e8re Krombacher 40cl",
          privateName: "Bi\u00e8re Krombacher 40cl",
          productCategories: [
            {
              name: "BI\u00c8RE AVEC ALCOOL",
              productCategoryFamily: { name: "AVEC ALCOOL" }
            }
          ],
          tva: {
            id: 1,
            name: "20%",
            rate: 20.0
          },
          isMenu: false
        },
        automaticDiscounts: [],
        stockAvailable: 0,
        eventPdvProducts: []
      },
      {
        priceTTC: 0,
        depositPriceTTC: 0,
        product: {
          id: 2471,
          name: "Consigne Gobelet Eco50",
          privateName: "Consigne Gobelet Eco50",
          productCategories: [
            {
              name: "CONSIGNE GOBELET",
              productCategoryFamily: { name: "GOBELETS" }
            }
          ],
          tva: {
            id: 1,
            name: "20%",
            rate: 20.0
          },
          isMenu: false
        },
        automaticDiscounts: [],
        stockAvailable: 0,
        eventPdvProducts: []
      }
    ]
  },
]
